import React from 'react';
import cn from 'classnames';
import styles from './InfoCell.module.scss';

const InfoCell = ({
  className,
  title,
  upperCaseTitle = true,
  text,
  additionalText,
}) => {
  return (
    <div className={cn(styles.root, className)}>
      <h4 className={styles.title}>{`${
        upperCaseTitle ? title.toUpperCase() : title
      }`}</h4>
      <p className={styles.text}>
        {text}
        {additionalText && <span className={styles.additionalText}> {additionalText}</span>}
      </p>
    </div>
  );
};

export default InfoCell;
